import React from 'react';
import { Flex, Text } from 'rebass';
import { AmExIcon, MastercardIcon, VisaIcon } from '../Icon/cards';
import { FragmentOf } from 'gql.tada';
import { STRIPE_PAYMENT_METHOD } from 'modes/company/pages/profile/CompanyProfile.query';

type Props = {
  method?: FragmentOf<typeof STRIPE_PAYMENT_METHOD>;
};

const iconHeight = 42;
const iconWidth = 60;

const cardBrandIcon = (brand: string | undefined) => {
  if (!brand) return '💳 Card';

  switch (brand.toLowerCase()) {
    case 'visa':
      return <VisaIcon width={iconWidth} height={iconHeight} />;
    case 'mastercard':
    case 'master card':
      return <MastercardIcon width={iconWidth} height={iconHeight} />;
    case 'amex':
    case 'american express':
      return <AmExIcon width={iconWidth} height={iconHeight} />;
    default:
      return '💳 Card';
  }
};

export default function SavedPaymentMethodCard({ method }: Props) {
  if (!method) {
    return (
      <Text variant="body2" color="fieldBorderHover">
        No payment method on file.
      </Text>
    );
  }

  return (
    <Flex
      sx={{
        alignItems: 'center',
        lineHeight: '14px',
        justifyContent: 'space-between',
        padding: 4,
        borderRadius: 'default',
        border: '1px solid #e5e5e5',
        boxShadow: 'paymentMethod',
        fontSize: '14px',
        color: '#555',
      }}
    >
      <Flex alignItems="center" sx={{ gap: 2 }}>
        <Flex>{cardBrandIcon(method.brand ?? undefined)}</Flex>****
        {method.last4}
      </Flex>
      <Flex>
        {method.expMonth &&
          method.expYear &&
          `Expires ${method.expMonth.toString().padStart(2, '0')}/${method.expYear}`}
      </Flex>
    </Flex>
  );
}
